var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../EventEmitter", "../../lib/interactjs/dist/interact", "../Shared/Helper", "../Shared/BoundingBox2D", "ts-vector-math", "decimal.js-light"], function (require, exports, EventEmitter_1, interact, Helper_1, BoundingBox2D_1, ts_vector_math_1, decimal_js_light_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var SnappingPoint = (function () {
        function SnappingPoint() {
            this.range = 25;
        }
        return SnappingPoint;
    }());
    exports.SnappingPoint = SnappingPoint;
    var LayoutElement = (function (_super) {
        __extends(LayoutElement, _super);
        function LayoutElement(width, height, x, y, id, parent, layout, ignoreTransform) {
            if (layout === void 0) { layout = null; }
            if (ignoreTransform === void 0) { ignoreTransform = false; }
            var _this = _super.call(this) || this;
            _this.preserveAspectRatio = true;
            _this.aspectRatio = 1.776;
            _this.resizeLockIndex = 0;
            _this.ignoreInteractions = false;
            _this.ignoreTapInteraction = false;
            _this.level = 0;
            _this.className = "";
            _this.selectedClassName = "";
            _this.layerIndex = 0;
            _this.width = new decimal_js_light_1.Decimal(width);
            _this.height = new decimal_js_light_1.Decimal(height);
            _this.x = x;
            _this.y = y;
            _this.rotation = 0;
            _this.layerIndex = 0;
            if (layout == null)
                _this.element = $('<div></div>');
            else
                _this.element = $(layout);
            _this.element.attr("id", id);
            _this.id = id;
            _this.SetParentHierarchy(parent, layout);
            _this.parent.append(_this.element);
            if (ignoreTransform == false) {
                _this.boundingBox = new BoundingBox2D_1.BoundingBox2D(ts_vector_math_1.Vector2.zero, ts_vector_math_1.Vector2.zero);
                _this.SetPosition(x, y);
                _this.SetSize(width, height);
                _this.snappingPoints = new Array();
            }
            return _this;
        }
        Object.defineProperty(LayoutElement.prototype, "ContentElement", {
            get: function () {
                if (this.contentElement != null && this.contentElement != undefined)
                    return this.contentElement;
                else
                    return this.element;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LayoutElement.prototype, "Level", {
            get: function () { return this.level; },
            set: function (value) {
                this.level = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LayoutElement.prototype, "ClassName", {
            get: function () {
                return this.className;
            },
            set: function (name) {
                this.className = name;
                this.element.attr("class", this.className);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LayoutElement.prototype, "SelectedClassName", {
            get: function () {
                return this.selectedClassName;
            },
            set: function (name) {
                this.selectedClassName = name;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LayoutElement.prototype, "LayerIndex", {
            get: function () {
                return this.layerIndex;
            },
            set: function (value) {
                this.layerIndex = value;
                this.element.css("z-index", value.toString());
            },
            enumerable: true,
            configurable: true
        });
        LayoutElement.prototype.SetParentHierarchy = function (parent, layout) {
            var jqContentElement = this.element.children('[data-type="content"]').first();
            if (jqContentElement != undefined && jqContentElement[0] != undefined)
                this.contentElement = jqContentElement;
            if (parent instanceof jQuery) {
                this.parent = parent;
            }
            else {
                this.parentLayoutElement = parent;
                if (this.parentLayoutElement.contentElement != null && this.parentLayoutElement.contentElement != undefined)
                    this.parent = this.parentLayoutElement.contentElement;
                else
                    this.parent = this.parentLayoutElement.element;
                if (this.parentLayoutElement.childrenLayoutElements == null)
                    this.parentLayoutElement.childrenLayoutElements = new Array();
                this.parentLayoutElement.childrenLayoutElements.push(this);
            }
        };
        LayoutElement.prototype.DeParent = function () {
            this.element.detach().appendTo("body");
            this.element.css("top", "0px");
            this.element.css("left", "0px");
        };
        LayoutElement.prototype.Parent = function () {
            this.element.detach().appendTo(this.parent);
        };
        LayoutElement.prototype.SetTextContent = function (value, filter) {
            if (filter === void 0) { filter = null; }
            if (filter == null)
                this.element.text(value);
            else
                this.element.find("*").filter(filter).text(value);
        };
        LayoutElement.prototype.GetTextContent = function (filter) {
            if (filter === void 0) { filter = null; }
            if (filter == null)
                return this.element.text();
            else
                this.element.find("*").filter(filter).text();
        };
        LayoutElement.prototype.SetHtmlContent = function (value, filter) {
            if (filter === void 0) { filter = null; }
            if (filter == null)
                this.element.html(value);
            else
                this.element.find("*").filter(filter).html(value);
        };
        LayoutElement.prototype.GetHtmlContent = function (filter) {
            if (filter === void 0) { filter = null; }
            if (filter == null)
                return this.element.html();
            else
                this.element.find("*").filter(filter).html();
        };
        LayoutElement.prototype.IgnoreInteractions = function (value) {
            this.ignoreInteractions = value;
        };
        LayoutElement.prototype.IgnoreTapInteraction = function (value) {
            this.ignoreTapInteraction = value;
        };
        LayoutElement.prototype.Select = function () {
            if (this.selectedClassName != "") {
                this.element.removeClass(this.className);
                this.element.addClass(this.selectedClassName);
            }
        };
        LayoutElement.prototype.Deselect = function () {
            if (this.className != "") {
                this.element.removeClass(this.selectedClassName);
                this.element.addClass(this.className);
            }
        };
        LayoutElement.prototype.Remove = function () {
            $("#" + this.id).remove();
        };
        LayoutElement.prototype.Hide = function () {
            $("#" + this.id).hide();
        };
        LayoutElement.prototype.Show = function () {
            $("#" + this.id).show();
        };
        LayoutElement.prototype.UnsetInteraction = function () {
            var obj = interact("#" + this.id);
            if (obj != null)
                obj.unset();
        };
        LayoutElement.prototype.GetLocalMinPoint = function () {
            var result = new ts_vector_math_1.Vector2();
            result.x = this.x;
            result.y = this.y;
            return result;
        };
        LayoutElement.prototype.GetLocalMaxPoint = function () {
            var result = new ts_vector_math_1.Vector2();
            result.x = this.x + this.width.toNumber();
            result.y = this.y + this.height.toNumber();
            return result;
        };
        LayoutElement.prototype.GetSize = function () {
            var result = this.GetLocalMaxPoint().subtract(this.GetLocalMinPoint());
            return result;
        };
        LayoutElement.prototype.GetSubElement = function (filter) {
            return this.element.find("*").filter(filter);
        };
        LayoutElement.prototype.GetRect = function () {
            return interact("#" + this.id).getRect();
        };
        LayoutElement.prototype.CalculatePercentWidth = function () {
            var value = this.width.div(this.parent.outerWidth());
            return value;
        };
        LayoutElement.prototype.CalculatePercentHeight = function () {
            var value = this.height.div(this.parent.outerHeight());
            return value;
        };
        LayoutElement.prototype.CalculatePercentX = function (decimalPlace) {
            if (decimalPlace === void 0) { decimalPlace = -1; }
            var value = this.x / this.parent.outerWidth();
            if (decimalPlace != -1)
                value = Helper_1.Helper.Round(value, decimalPlace);
            return value;
        };
        LayoutElement.prototype.CalculatePercentY = function (decimalPlace) {
            if (decimalPlace === void 0) { decimalPlace = -1; }
            var value = this.y / this.parent.outerHeight();
            if (decimalPlace != -1)
                value = Helper_1.Helper.Round(value, decimalPlace);
            return value;
        };
        LayoutElement.prototype.SetX = function (value) {
            this.SetPosition(value, this.y);
        };
        LayoutElement.prototype.SetY = function (value) {
            this.SetPosition(this.x, value);
        };
        LayoutElement.prototype.SetPercentX = function (value) {
            this.pX = value;
            var result = this.parent.outerWidth() * value;
            this.SetPosition(result, this.y);
            return result;
        };
        LayoutElement.prototype.SetPercentY = function (value) {
            this.pY = value;
            var result = this.parent.outerHeight() * value;
            this.SetPosition(this.x, result);
            return result;
        };
        LayoutElement.prototype.SetPercentWidth = function (value) {
            this.pWidth = value;
            var result = value.mul(this.parent.outerWidth());
            this.width = result;
            this.element.width(result.toNumber());
            return result;
        };
        LayoutElement.prototype.SetPercentHeight = function (value) {
            this.pHeight = value;
            var result = value.mul(this.parent.outerHeight());
            this.height = result;
            this.element.height(result.toNumber());
            return result;
        };
        LayoutElement.prototype.SetHeightByAspectRatio = function (value) {
            var result = this.width.dividedBy(value);
            this.element.height(result.toNumber());
            this.height = result;
            this.pHeight = this.CalculatePercentHeight();
            return result;
        };
        LayoutElement.prototype.SetWidthByAspectRatio = function (value) {
            var result = this.height.dividedBy(value);
            this.element.width(result.toNumber());
            this.width = result;
            this.pWidth = this.CalculatePercentWidth();
            return result;
        };
        LayoutElement.prototype.ApplyTouch = function () {
            if (this.ignoreTapInteraction)
                return;
            interact("#" + this.id)
                .on('tap', this.TouchElement.bind(this));
        };
        LayoutElement.prototype.ApplyDrag = function (snappingPoints) {
            if (this.ignoreInteractions)
                return;
            interact("#" + this.id)
                .draggable({
                snap: {
                    targets: snappingPoints,
                    range: 25,
                    relativePoints: [{ x: 0, y: 0 }, { x: 0, y: 1 }, { x: 1, y: 0 }, { x: 1, y: 1 }]
                },
                inertia: false,
                restrict: {
                    restriction: "parent",
                    endOnly: true,
                    elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
                },
                autoScroll: true,
                onmove: this.MoveElement.bind(this),
                onend: this.DropElement.bind(this)
            });
        };
        LayoutElement.prototype.ApplyGridDrag = function (gridX, gridY) {
            if (this.ignoreInteractions)
                return;
            interact("#" + this.id)
                .draggable({
                snap: {
                    targets: [
                        interact.createSnapGrid({ x: gridX, y: gridY })
                    ],
                    range: Infinity,
                    relativePoints: [{ x: 0, y: 0 }]
                },
                inertia: false,
                restrict: {
                    restriction: "parent",
                    endOnly: true,
                    elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
                },
                autoScroll: true,
                onmove: this.MoveElement.bind(this),
                onend: this.DropElement.bind(this)
            });
        };
        LayoutElement.prototype.AddOnMoveEvent = function (host) {
            var element = this;
            this.interactable = interact("#" + this.id)
                .on('move', function (event) {
                var interaction = event.interaction;
                if (interaction.pointerIsDown && !interaction.interacting()) {
                    host.FireEvent("MovedOverElement", { event: event, layoutElement: element });
                }
            });
        };
        LayoutElement.prototype.StartInteraction = function (interactionName, interaction) {
            if (this.ignoreInteractions)
                return;
            interaction.start({ name: interactionName }, this.interactable, this.element.get(0));
        };
        LayoutElement.prototype.RecalculateTransform = function () {
            var x = this.pX * this.parent.outerWidth();
            var y = this.pY * this.parent.outerHeight();
            var w = this.pWidth.mul(new decimal_js_light_1.Decimal(this.parent.outerWidth()));
            var h = this.pHeight.mul(new decimal_js_light_1.Decimal(this.parent.outerHeight()));
            this.SetPosition(x, y);
            this.SetSize(w.toNumber(), h.toNumber());
        };
        LayoutElement.prototype.MoveElement = function (event) {
            var target = event.target, x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx, y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
            this.x = x;
            this.y = y;
            this.SetTransform(target);
            this.UpdatePercentPosition();
            this.CalculateCenterPosition();
            this.CalculateBoundingBox();
            this.FireEvent(LayoutElement.OnElementMoved, { id: this.id });
        };
        LayoutElement.prototype.TouchElement = function (event) {
            this.FireEvent(LayoutElement.OnElementTouched, { id: this.id });
        };
        LayoutElement.prototype.DropElement = function (event) {
            console.log("dropped: " + this.id);
            this.FireEvent(LayoutElement.OnElementDropped, { id: this.id });
            this.resizeLockIndex = 0;
        };
        LayoutElement.prototype.ApplyResize = function (snappingPoints) {
            if (this.ignoreInteractions)
                return;
            var xParent = parseInt(this.parent.css("left"));
            var yParent = parseInt(this.parent.css("top"));
            this.interactable = interact("#" + this.id)
                .resizable({
                snap: {
                    targets: snappingPoints,
                    range: 25,
                    relativePoints: [{ x: 0, y: 0 }, { x: 0, y: 1 }, { x: 1, y: 0 }, { x: 1, y: 1 }]
                },
                edges: { left: true, right: true, bottom: true, top: true },
                restrictEdges: {
                    outer: 'parent',
                    endOnly: true,
                },
                onmove: this.ResizeObject.bind(this),
                onend: this.DropElement.bind(this),
                restrictSize: {
                    min: { width: 25, height: 25 },
                },
                inertia: false,
            });
        };
        LayoutElement.prototype.UpdatePercentPosition = function () {
            this.pX = this.CalculatePercentX();
            this.pY = this.CalculatePercentY();
        };
        LayoutElement.prototype.UpdatePercentSize = function () {
            this.pWidth = this.CalculatePercentWidth();
            this.pHeight = this.CalculatePercentHeight();
        };
        LayoutElement.prototype.SetSize = function (width, height) {
            this.element.width(width);
            this.element.height(height);
            this.width = new decimal_js_light_1.Decimal(width);
            this.height = new decimal_js_light_1.Decimal(height);
            this.UpdatePercentSize();
            this.lastWidth = width;
            this.lastHeight = height;
            this.CalculateBoundingBox();
        };
        LayoutElement.prototype.ScaleSize = function (value) {
        };
        LayoutElement.prototype.SetRotation = function (value) {
            this.rotation = value;
            var target = this.element.get(0);
            this.SetTransform(target);
        };
        LayoutElement.prototype.SetRotationViaSize = function (value) {
            var rotDif = Math.abs(this.rotation - value);
            if (rotDif != 180 && rotDif != 0)
                this.SetSize(this.height.toNumber(), this.width.toNumber());
            this.rotation = value;
        };
        LayoutElement.prototype.SetPosition = function (x, y) {
            var target = this.element.get(0);
            this.element.attr("data-x", x);
            this.element.attr("data-y", y);
            this.x = x;
            this.y = y;
            this.SetTransform(target);
            this.UpdatePercentPosition();
            this.CalculateCenterPosition();
            this.CalculateBoundingBox();
        };
        LayoutElement.prototype.SetTransform = function (htmlElement) {
            htmlElement.style.webkitTransform =
                htmlElement.style.transform =
                    'translate(' + this.x + 'px, ' + this.y + 'px)';
        };
        LayoutElement.prototype.ResizeObject = function (event) {
            var target = event.target, x = (parseFloat(target.getAttribute('data-x')) || 0), y = (parseFloat(target.getAttribute('data-y')) || 0);
            if (this.preserveAspectRatio) {
                if (Math.abs(event.deltaRect.left) == 0 && Math.abs(event.deltaRect.top) > 0 && Math.abs(event.deltaRect.height) > 0 || this.resizeLockIndex == 5) {
                    this.resizeLockIndex = 5;
                    this.height = new decimal_js_light_1.Decimal(event.rect.height);
                    this.width = new decimal_js_light_1.Decimal(event.rect.height * this.aspectRatio);
                    y += this.lastHeight - this.height.toNumber();
                }
                else if (Math.abs(event.deltaRect.left) > 0 && Math.abs(event.deltaRect.top) > 0 || this.resizeLockIndex == 4) {
                    this.resizeLockIndex = 4;
                    this.height = new decimal_js_light_1.Decimal(event.rect.height);
                    this.width = new decimal_js_light_1.Decimal(event.rect.height * this.aspectRatio);
                    x += this.lastWidth - this.width.toNumber();
                    y += event.deltaRect.top;
                }
                else if (Math.abs(event.deltaRect.width) > 0 && Math.abs(event.deltaRect.height) > 0 || this.resizeLockIndex == 1) {
                    this.resizeLockIndex = 1;
                    this.width = new decimal_js_light_1.Decimal(event.rect.width);
                    this.height = new decimal_js_light_1.Decimal(event.rect.width / this.aspectRatio);
                    x += event.deltaRect.left;
                    y += event.deltaRect.top;
                }
                else if (Math.abs(event.deltaRect.height) > 0 || this.resizeLockIndex == 2) {
                    this.resizeLockIndex = 2;
                    this.height = new decimal_js_light_1.Decimal(event.rect.height);
                    this.width = new decimal_js_light_1.Decimal(event.rect.height * this.aspectRatio);
                    x += event.deltaRect.left;
                    y += event.deltaRect.top;
                }
                else if (Math.abs(event.deltaRect.width) > 0 || this.resizeLockIndex == 3) {
                    this.resizeLockIndex = 3;
                    this.width = new decimal_js_light_1.Decimal(event.rect.width);
                    this.height = new decimal_js_light_1.Decimal(event.rect.width / this.aspectRatio);
                    x += event.deltaRect.left;
                    y += event.deltaRect.top;
                }
            }
            else {
                this.width = new decimal_js_light_1.Decimal(event.rect.width);
                this.height = new decimal_js_light_1.Decimal(event.rect.height);
                x += event.deltaRect.left;
                y += event.deltaRect.top;
            }
            target.style.width = this.width + 'px';
            target.style.height = this.height + 'px';
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
            this.x = x;
            this.y = y;
            this.SetTransform(target);
            this.UpdatePercentPosition();
            this.UpdatePercentSize();
            this.CalculateCenterPosition();
            this.CalculateBoundingBox();
            this.lastWidth = this.width.toNumber();
            this.lastHeight = this.height.toNumber();
        };
        LayoutElement.prototype.CalculateCenterPosition = function () {
            this.position = this.boundingBox.center;
        };
        LayoutElement.prototype.CalculateBoundingBox = function () {
            this.boundingBox.SetMinMax(this.GetLocalMinPoint(), this.GetLocalMaxPoint());
        };
        LayoutElement.OnElementDropped = "OnElementDropped";
        LayoutElement.OnElementMoved = "OnElementMoved";
        LayoutElement.OnElementTouched = "OnElementTouched";
        LayoutElement.OnElementEnteredDropzone = "OnElementEnteredDropzone";
        LayoutElement.OnElementLeftDropzone = "OnElementLeftDropzone";
        LayoutElement.OnElementDroppedInDropzone = "OnElementDroppedInDropzone";
        LayoutElement.OnElementEdit = "OnElementEdit";
        return LayoutElement;
    }(EventEmitter_1.EventEmitter));
    exports.LayoutElement = LayoutElement;
});
//# sourceMappingURL=LayoutElement.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/LayoutDesigner/LayoutElement.js
// module id = 29
// module chunks = 0